import {
    ResponsiveContainer,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Radar,
    Legend,
    Tooltip as ReChartsTooltip
} from 'recharts';
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Widget from "../../prefabricated/Widget";
import {
    bbErrorSection, bbFindEntityWithinPortfolioOrSelf,
} from "../../../util/bbHelpers";
import React from "react";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {useSelector} from "react-redux";
import Skeleton from "react-loading-skeleton";

const testData = [
    {
        dim:"test1",
        value: 3
    },
    {
        dim:"test2",
        value: 2
    },
    {
        dim:"test3",
        value: 4
    },
    {
        dim:"test4",
        value: 5
    },
];

const RenderChart = (
    {
        showVectorRiskScore = false,
        dataBranch = null,
        small = false,
    }
    ) => {

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, entityInView, loadingPortfolios, loadingPortfoliosError} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    const dataBranchResults = myEntity
    && myEntity.last_cycle
        ? dataBranch
        && myEntity.last_cycle[`${dataBranch}`]
            ? myEntity.last_cycle[`${dataBranch}`]
            : myEntity.last_cycle
        : null;

    const portfolioAverages = portfolios && customerIdToUse && portfolios[customerIdToUse] &&  portfolios[customerIdToUse].averages;

    // const averageValue = avgValue ? avgValue : portfolioAverages && portfolioAverages[avgVarName];


    const chartData = dataBranchResults ? [] : null;

    const subdomains = dataBranchResults && portfolioAverages && dataBranchResults.subdomains !== null
        ? {
            dim: 'Subdomains',
            value: dataBranchResults.subdomains,
            avg: portfolioAverages.subdomains_average
        }
        : {}

    const services = dataBranchResults && portfolioAverages && dataBranchResults.services !== null
        ? {
            dim: 'Services',
            value: dataBranchResults.services,
            avg: portfolioAverages.services_average
        }
        : {}

    const dangerousServices = dataBranchResults && portfolioAverages && dataBranchResults.services_high_risk !== null
        ? {
            dim: 'Dangerous Services',
            value: dataBranchResults.services_high_risk,
            avg: portfolioAverages.high_risk_services_average
        }
        : {}


    const vectors = dataBranchResults && portfolioAverages && dataBranchResults.vectors !== null
        ? {
            dim: 'Vectors',
            value: dataBranchResults.vectors,
            avg: portfolioAverages.vectors_average
        }
        : {}

    const vulnerabilities = dataBranchResults && portfolioAverages && dataBranchResults.vulnerabilities !== null
        ? {
            dim: 'Vulnerabilities',
            value: dataBranchResults.vulnerabilities,
            avg: portfolioAverages.vulnerabilities_average
        }
        : {}

    const targets = dataBranchResults && portfolioAverages && dataBranchResults.targets !== null
        ? {
            dim: 'Hosts',
            value: dataBranchResults.targets,
            avg: portfolioAverages.target_average
        }
        : {}

    const identities = dataBranchResults && portfolioAverages && dataBranchResults.identities !== null
        ? {
            dim: 'Identities',
            value: dataBranchResults.identities,
            avg: portfolioAverages.identities_average
        }
        : {}

    if(Array.isArray(chartData)){
        chartData.push(vulnerabilities, vectors, identities , subdomains,  services, targets  );
    }

    // console.log("New radar chart widget. Looking for dataBranch", dataBranch, "found this:", dataBranchResults, "myEntity.last_cycle", myEntity && myEntity.last_cycle, "chart data is", chartData);


    // return true;

    const substance = <>
                {/*<Tooltip disableFocusListener*/}
                {/*         title={"How your BreachRisk™ Score - your risk of a breach - has changed over time. Lower scores are better."}>*/}
                {/*    <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}*/}
                {/*                   className={`text-muted`}/>*/}
                {/*</Tooltip>*/}
                {/*<div className="row">*/}
                {/*    <div className={"col-12"}>*/}


                {/*    </div>*/}
                {/*</div>*/}
                <div className="row" style={{height: small ? 150 : 300}}>
                <div className={"col-12"}>
                    {!portfolios || loadingPortfolios[customerIdToUse] ?
                        <Skeleton count={small ? 5 : 10}/>
                        : !myEntity || loadingPortfoliosError[customerIdToUse] ?
                            <div className={"text-center"}>
                                {bbErrorSection("80px")}
                            </div>
                            :
                            <ResponsiveContainer width="100%" height="100%">
                                <RadarChart cx="50%" cy="45%" outerRadius="70%" width={small ? 500 : 730} height={small ? 150 : 250} data={chartData}>
                                    <PolarGrid />
                                    {!small &&
                                        <PolarAngleAxis dataKey={"dim"}/>
                                    }

                                    {!small
                                       ? <PolarRadiusAxis scale={"sqrt"}/>
                                        : <PolarRadiusAxis scale={"sqrt"} tick={false} axisLine={false}/>
                                    }

                                    {!small &&
                                        <ReChartsTooltip />
                                    }

                                    <Radar name="Global Average" dataKey="avg" stroke="#333333" fill="#333333" fillOpacity={0.7} />
                                    <Radar name="This Organization" dataKey="value" stroke="#69A5FF" fill="#69A5FF" fillOpacity={0.75} />

                                    {!small &&
                                        <Legend />
                                    }

                                </RadarChart>
                            </ResponsiveContainer>
                    }
                </div>
            </div>
        </>

    return <> {small
        ? <div>
            {substance}
        </div>
        :   <Widget styleName={`p-2 animated fadeIn animation-duration-5 tourBRAttackSurfaceBenchmarkWidget`}>
                <Tooltip disableFocusListener
                         title={"Attack Surface is important context that attackers consider when surveying, planning, and conducting attacks. Here's how this organization compares to global averages."}>
                    <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}
                                   className={`text-muted`}/>
                </Tooltip>
                <div className="row"  id={""}>
                    <div className={"col-12"}>
                        <h1 className={"text-center"}>Attack Surface Benchmarks</h1>
                        {/*<h2 className={"text-center"}>Comparative Exposure</h2>*/}


                    </div>
                </div>
                {substance}
            </Widget>
        }


    </>
};

export default RenderChart;